<template>
    <div>
        <info-item
            :isEnabled="isEnabled"
            :label="resource('DmVisualizer_ChangeInfo_Website')"
            @set-enabled="$emit('set-enabled', $event)"
        >
            <info-text-input 
                :placeholder="resource('DmVisualizer_ChangeInfo_Placeholder_Website')"
                :isEnabled="isEnabled"
                v-model="website"
                @input="$emit('input', $event)"
            />
        </info-item>
    </div>
</template>

<script>
import resourceMixin from '../../../../Util/Mixins/resources';

import InfoItem from './InfoItem.vue';
import InfoTextInput from './Components/InfoTextInput.vue';

export default {
    name: 'info-website',
    mixins: [resourceMixin],
    components: {
        InfoItem,
        InfoTextInput
    },
    data() {
        return {
            website: ""
        };
    },
    props: {
        isEnabled: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
